export default __webpack_public_path__ + "static/media/logo02.f8653fb8.svg";